export default __webpack_public_path__ + "static/media/line.6a7e195a.png";